/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";
import UriEntry, { DisplayFromFHIRUri } from "./UriEntry";
import { DataEntry } from "./ArrayEntry";
import { CodingDisplay } from "./CodingEntry";
import { DisplayFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import { getDateDisplay, getDateTimeDisplay } from "./PeriodEntry";
import { displayStringFromFHIRIdentifier } from "./IdentifierEntry";
import { DisplayFromFHIRMarkdown } from "./MarkdownEntry";
import { DisplayFromFHIRReference } from "./ReferenceEntry";

const DisplayFromFHIRExtension = ({ extension }) => {
  if (extension) {
    if (Array.isArray(extension) || typeof extension != "object") {
      return <>[ERROR: Extension data not interpretable.]</>;
    } else {
      let innerExtension = extension.extension;
      let url = extension.url;
      let valueDatatype;
      for (const key in extension) {
        if (key.includes('value')) {
          valueDatatype = key.replace('value', "");
        }
      }
      let value = extension["value" + valueDatatype];
      return <div style={{ marginLeft: "24px", wordBreak: "break-all" }}>
        {url && <><b>Extension URL: </b> <DisplayFromFHIRUri uri={url} /><br /></>}
        {value && <>
          <b>Extension Value: </b>
          {(valueDatatype === "Coding") && <CodingDisplay coding={value} />}
          {(valueDatatype === "CodeableConcept") && <DisplayFromFHIRCodeableConcept codeableConcept={value} />}
          {(valueDatatype === "Date") && <>{getDateDisplay(value)}</>}
          {(valueDatatype === "DateTime") && <>{getDateTimeDisplay(value)}</>}
          {(valueDatatype === "Identifier") && <>{displayStringFromFHIRIdentifier(value)}</>}
          {(valueDatatype === "Markdown") && <DisplayFromFHIRMarkdown markdown={value} />}
          {(valueDatatype === "Reference") && <DisplayFromFHIRReference reference={value} />}
          {(valueDatatype === "String" || valueDatatype === "Code") && <>{value}</>}
          {(valueDatatype === "Uri" || valueDatatype === "Canonical") && <DisplayFromFHIRUri uri={value} />}
          <br />
        </>}
        {innerExtension?.length > 0 && <>
          <p><b>Extensions:</b></p>
          {innerExtension.map(innerExtension => { return <DisplayFromFHIRExtension extension={innerExtension} /> })}
        </>}
      </div>
    }
  } else {
    return <></>
  }
}

const ExtensionEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed,
  extensionUrl, extensionValueType }) => {

  const [extensionState, setExtensionState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);
  const [extensionDatatypeState, setExtensionDatatypeState] = useState("");

  useEffect(() => {
    let startingExtension = { "url": "" }
    let startingExtensionDatatype = "";
    if (startingValue) {
      for (let key in startingValue) {
        startingExtension[key] = startingValue[key];
        if (key.includes("value")) {
          startingExtensionDatatype = key.replace("value", "");
          if (startingExtensionDatatype === "Uri") {
            startingExtensionDatatype = "uri";
          }
          if (startingExtensionDatatype === "String") {
            startingExtensionDatatype = "string";
          }
          if (startingExtensionDatatype === "Code") {
            startingExtensionDatatype = "code";
          }
          if (startingExtensionDatatype === "Integer") {
            startingExtensionDatatype = "integer";
          }
          if (startingExtensionDatatype === "Decimal") {
            startingExtensionDatatype = "decimal";
          }
          if (startingExtensionDatatype === "PositiveInt") {
            startingExtensionDatatype = "positiveInt";
          }
          if (startingExtensionDatatype === "UnsignedInt") {
            startingExtensionDatatype = "unsignedInt";
          }
          if (startingExtensionDatatype === "Date") {
            startingExtensionDatatype = "date";
          }
          if (startingExtensionDatatype === "DateTime") {
            startingExtensionDatatype = "dateTime";
          }
          if (startingExtensionDatatype === "Canonical") {
            startingExtensionDatatype = "canonical";
          }
          if (startingExtensionDatatype === "Boolean") {
            startingExtensionDatatype = "boolean";
          }
          if (startingExtensionDatatype === "Time") {
            startingExtensionDatatype = "time";
          }
        }
      }
    } else {
      startingExtension.url = extensionUrl || "";
    }
    setExtensionState(JSON.parse(JSON.stringify(startingExtension)));
    setExtensionDatatypeState(extensionValueType || startingExtensionDatatype || "");
  }, []);

  useEffect((() => {
    if (Object.keys(extensionState).length) {
      let newExtension = {};
      for (let key in extensionState) {
        newExtension[key] = extensionState[key];
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newExtension }; });
    }
  }), [extensionState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRExtension extension={startingValue} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(extensionState).length > 0) {
    return <div>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <UriEntry elementName='url' fieldLabel='Extension URL'
          startingValue={extensionState.url} setResourceState={setExtensionState} />
        <TextField style={{ width: "100%" }} className="inputField" type='text' label={'Extension Datatype'}
          size="small" variant='outlined' value={extensionDatatypeState}
          onChange={(e) => { setExtensionDatatypeState(e.target.value) }} />
        {extensionDatatypeState &&
          <DataEntry datatype={extensionDatatypeState}
            elementName={'value' + extensionDatatypeState[0].toUpperCase() + extensionDatatypeState.slice(1)}
            fieldLabel='Extension Value' startCollapsed
            startingValue={extensionState['value' + extensionDatatypeState[0].toUpperCase() + extensionDatatypeState.slice(1)]}
            setResourceState={setExtensionState} />
        }
      </div>
    </div>
  }
};

export default ExtensionEntry;
export { DisplayFromFHIRExtension };